__turbopack_context__.v({
  "actionPlanSection": "RtGD-q_actionPlanSection",
  "affectedSection": "RtGD-q_affectedSection",
  "ambientGlow": "RtGD-q_ambientGlow",
  "backLink": "RtGD-q_backLink",
  "badgeIcon": "RtGD-q_badgeIcon",
  "breakdownTitle": "RtGD-q_breakdownTitle",
  "categoryAnalysisHeader": "RtGD-q_categoryAnalysisHeader",
  "categoryAnalysisIntro": "RtGD-q_categoryAnalysisIntro",
  "categoryAnalysisSection": "RtGD-q_categoryAnalysisSection",
  "categoryBadge": "RtGD-q_categoryBadge",
  "categoryBar": "RtGD-q_categoryBar",
  "categoryBarFill": "RtGD-q_categoryBarFill",
  "categoryBreakdown": "RtGD-q_categoryBreakdown",
  "categoryCount": "RtGD-q_categoryCount",
  "categoryIcon": "RtGD-q_categoryIcon",
  "categoryInfo": "RtGD-q_categoryInfo",
  "categoryItem": "RtGD-q_categoryItem",
  "categoryList": "RtGD-q_categoryList",
  "categoryName": "RtGD-q_categoryName",
  "categoryRank": "RtGD-q_categoryRank",
  "clearFilter": "RtGD-q_clearFilter",
  "compareViewSection": "RtGD-q_compareViewSection",
  "comparisonHeader": "RtGD-q_comparisonHeader",
  "comparisonInsights": "RtGD-q_comparisonInsights",
  "comparisonIntro": "RtGD-q_comparisonIntro",
  "comparisonSection": "RtGD-q_comparisonSection",
  "comparisonStat": "RtGD-q_comparisonStat",
  "comparisonStatLabel": "RtGD-q_comparisonStatLabel",
  "comparisonStatNote": "RtGD-q_comparisonStatNote",
  "comparisonStatNumber": "RtGD-q_comparisonStatNumber",
  "comparisonStats": "RtGD-q_comparisonStats",
  "container": "RtGD-q_container",
  "critical": "RtGD-q_critical",
  "ctaButtons": "RtGD-q_ctaButtons",
  "ctaContact": "RtGD-q_ctaContact",
  "ctaContent": "RtGD-q_ctaContent",
  "ctaDescription": "RtGD-q_ctaDescription",
  "ctaIcon": "RtGD-q_ctaIcon",
  "ctaOffer": "RtGD-q_ctaOffer",
  "ctaOfferHead": "RtGD-q_ctaOfferHead",
  "ctaOfferName": "RtGD-q_ctaOfferName",
  "ctaOfferPrice": "RtGD-q_ctaOfferPrice",
  "ctaOfferSummary": "RtGD-q_ctaOfferSummary",
  "ctaOffers": "RtGD-q_ctaOffers",
  "ctaPrimary": "RtGD-q_ctaPrimary",
  "ctaSecondary": "RtGD-q_ctaSecondary",
  "ctaSection": "RtGD-q_ctaSection",
  "ctaTitle": "RtGD-q_ctaTitle",
  "desktop": "RtGD-q_desktop",
  "detailLabel": "RtGD-q_detailLabel",
  "deviceBadge": "RtGD-q_deviceBadge",
  "donutCenter": "RtGD-q_donutCenter",
  "donutChart": "RtGD-q_donutChart",
  "donutLabel": "RtGD-q_donutLabel",
  "donutNumber": "RtGD-q_donutNumber",
  "donutSegment": "RtGD-q_donutSegment",
  "donutSvg": "RtGD-q_donutSvg",
  "downloadButton": "RtGD-q_downloadButton",
  "effortBar": "RtGD-q_effortBar",
  "effortDot": "RtGD-q_effortDot",
  "effortFilled": "RtGD-q_effortFilled",
  "effortLabel": "RtGD-q_effortLabel",
  "elementList": "RtGD-q_elementList",
  "executiveSummary": "RtGD-q_executiveSummary",
  "expandButton": "RtGD-q_expandButton",
  "fadeIn": "RtGD-q_fadeIn",
  "findingBadges": "RtGD-q_findingBadges",
  "findingCard": "RtGD-q_findingCard",
  "findingDescription": "RtGD-q_findingDescription",
  "findingDetails": "RtGD-q_findingDetails",
  "findingHeader": "RtGD-q_findingHeader",
  "findingHighlight": "RtGD-q_findingHighlight",
  "findingMeta": "RtGD-q_findingMeta",
  "findingTitle": "RtGD-q_findingTitle",
  "findingsGrid": "RtGD-q_findingsGrid",
  "findingsHeader": "RtGD-q_findingsHeader",
  "findingsSection": "RtGD-q_findingsSection",
  "findingsSubtitle": "RtGD-q_findingsSubtitle",
  "footerMeta": "RtGD-q_footerMeta",
  "header": "RtGD-q_header",
  "headerActions": "RtGD-q_headerActions",
  "headerBadge": "RtGD-q_headerBadge",
  "headerContent": "RtGD-q_headerContent",
  "headerMeta": "RtGD-q_headerMeta",
  "headerThumbnail": "RtGD-q_headerThumbnail",
  "headerThumbnailImg": "RtGD-q_headerThumbnailImg",
  "heroActions": "RtGD-q_heroActions",
  "heroDeviceLabel": "RtGD-q_heroDeviceLabel",
  "heroMeta": "RtGD-q_heroMeta",
  "heroMetaItem": "RtGD-q_heroMetaItem",
  "heroPrimaryBtn": "RtGD-q_heroPrimaryBtn",
  "heroScore": "RtGD-q_heroScore",
  "heroScoreCenter": "RtGD-q_heroScoreCenter",
  "heroScoreCircle": "RtGD-q_heroScoreCircle",
  "heroScoreLabel": "RtGD-q_heroScoreLabel",
  "heroScoreNumber": "RtGD-q_heroScoreNumber",
  "heroScoreSvg": "RtGD-q_heroScoreSvg",
  "heroScreenshot": "RtGD-q_heroScreenshot",
  "heroScreenshotImg": "RtGD-q_heroScreenshotImg",
  "heroScreenshotOverlay": "RtGD-q_heroScreenshotOverlay",
  "heroScreenshotStats": "RtGD-q_heroScreenshotStats",
  "heroSeverityCount": "RtGD-q_heroSeverityCount",
  "heroSeverityDot": "RtGD-q_heroSeverityDot",
  "heroSeverityItem": "RtGD-q_heroSeverityItem",
  "heroSeverityLabel": "RtGD-q_heroSeverityLabel",
  "heroSeverityList": "RtGD-q_heroSeverityList",
  "heroStatBadge": "RtGD-q_heroStatBadge",
  "heroSummary": "RtGD-q_heroSummary",
  "heroTitle": "RtGD-q_heroTitle",
  "heroUrl": "RtGD-q_heroUrl",
  "heroUrlText": "RtGD-q_heroUrlText",
  "high": "RtGD-q_high",
  "highlightPulse": "RtGD-q_highlightPulse",
  "insightCard": "RtGD-q_insightCard",
  "insightContent": "RtGD-q_insightContent",
  "insightDescription": "RtGD-q_insightDescription",
  "insightIcon": "RtGD-q_insightIcon",
  "insightInfo": "RtGD-q_insightInfo",
  "insightPriority": "RtGD-q_insightPriority",
  "insightSuccess": "RtGD-q_insightSuccess",
  "insightTitle": "RtGD-q_insightTitle",
  "insightWarning": "RtGD-q_insightWarning",
  "insightsList": "RtGD-q_insightsList",
  "insightsTitle": "RtGD-q_insightsTitle",
  "legendActive": "RtGD-q_legendActive",
  "legendCount": "RtGD-q_legendCount",
  "legendDot": "RtGD-q_legendDot",
  "legendItem": "RtGD-q_legendItem",
  "legendLabel": "RtGD-q_legendLabel",
  "low": "RtGD-q_low",
  "medium": "RtGD-q_medium",
  "metaBlock": "RtGD-q_metaBlock",
  "metaItem": "RtGD-q_metaItem",
  "metaLabel": "RtGD-q_metaLabel",
  "metaValue": "RtGD-q_metaValue",
  "methodNote": "RtGD-q_methodNote",
  "mobile": "RtGD-q_mobile",
  "moreElements": "RtGD-q_moreElements",
  "principleBadge": "RtGD-q_principleBadge",
  "principleSection": "RtGD-q_principleSection",
  "principleTag": "RtGD-q_principleTag",
  "principleTagMore": "RtGD-q_principleTagMore",
  "principlesIntro": "RtGD-q_principlesIntro",
  "principlesSection": "RtGD-q_principlesSection",
  "principlesTags": "RtGD-q_principlesTags",
  "pulse": "RtGD-q_pulse",
  "quickWinsSection": "RtGD-q_quickWinsSection",
  "recommendationBox": "RtGD-q_recommendationBox",
  "recommendationIcon": "RtGD-q_recommendationIcon",
  "recommendationSection": "RtGD-q_recommendationSection",
  "reportFooter": "RtGD-q_reportFooter",
  "scoreVisualization": "RtGD-q_scoreVisualization",
  "screenshot": "RtGD-q_screenshot",
  "screenshotCompare": "RtGD-q_screenshotCompare",
  "screenshotCompareItem": "RtGD-q_screenshotCompareItem",
  "screenshotLabel": "RtGD-q_screenshotLabel",
  "screenshotMobile": "RtGD-q_screenshotMobile",
  "screenshotOverlay": "RtGD-q_screenshotOverlay",
  "screenshotSection": "RtGD-q_screenshotSection",
  "screenshotWrapper": "RtGD-q_screenshotWrapper",
  "sectionLabel": "RtGD-q_sectionLabel",
  "sectionTitle": "RtGD-q_sectionTitle",
  "severityBadge": "RtGD-q_severityBadge",
  "severityCritical": "RtGD-q_severityCritical",
  "severityHigh": "RtGD-q_severityHigh",
  "severityLegend": "RtGD-q_severityLegend",
  "severityLow": "RtGD-q_severityLow",
  "severityMedium": "RtGD-q_severityMedium",
  "summaryGrid": "RtGD-q_summaryGrid",
  "summaryHeader": "RtGD-q_summaryHeader",
  "summaryIntro": "RtGD-q_summaryIntro",
  "title": "RtGD-q_title",
  "total": "RtGD-q_total",
  "urlLink": "RtGD-q_urlLink",
  "urlText": "RtGD-q_urlText",
  "visualHero": "RtGD-q_visualHero",
});
